import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { FeedbackLevel } from '../../interfaces/FeedbackLevel';

export interface ToastMessage {
    level?: FeedbackLevel;
    message: string[] | string;
    id: number;
    onClose: (id: number) => void;
}

const ToastNotification: React.FC<ToastMessage> = ({ level, message, id, onClose }) => {
    return (
        <ToastContainer position="bottom-end" className="pt-6 pe-4 w-25">
            <Toast
                key={id}
                onClose={() => onClose(id)}
                onExited={() => onClose(id)}
                autohide
                delay={4000}
                className={`mb-2 border-${level} w-100`}
            >
                <Toast.Body>
                    {!Array.isArray(message) || message.length === 1 ? (
                        message
                    ) : (
                        <ul>
                            {message.map((m, index) => (
                                <li key={`${id}-${index}`}>{m}</li>
                            ))}
                        </ul>
                    )}
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default ToastNotification;
